let dingDing

const handleScan = async ({ onScanned, onFailed }) => {
	if (!dingDing) {
		const m = await import(/* webpackChunkName: "chunks/dingDinginterface" */ 'tyan/public/interfaces/dingDing')
		m && m.default && (dingDing = m.default)
	}
	dingDing
		? dingDing.scanCode({
			onScaned: ({ code }) => {
				onScanned(code)
			},
			onFail: (err) => {
				onFailed && onFailed(err)
				//Tyan.pubForm.showConfirm(JSON.stringify(err), () => { })
			}
		})
		: Tyan.pubForm.showError('系统错误，请与系统管理联系:dingDing module not found')
}

export default handleScan